/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vendor_Return_Status_CancelledInputs */

const en_vendor_return_status_cancelled = /** @type {(inputs: Vendor_Return_Status_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelled`)
};

/**
* | output |
* | --- |
* | "Cancelled" |
*
* @param {Vendor_Return_Status_CancelledInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const vendor_return_status_cancelled = /** @type {((inputs?: Vendor_Return_Status_CancelledInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vendor_Return_Status_CancelledInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_vendor_return_status_cancelled(inputs)
});